import React from 'react';
import { getCredentialingPanelList } from 'api/credentialing';
import { TCredentialingPanelRow } from 'types/credentialing';

let globalData: TCredentialingPanelRow[] = [];

const useCredentialingPanels = (): [TCredentialingPanelRow[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TCredentialingPanelRow[]>(globalData);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const result = await getCredentialingPanelList();
            if (!result.error) {
                const list: TCredentialingPanelRow[] = result?.data?.data || [];
                globalData = list;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useCredentialingPanels;
